import { Fragment } from "react";
import Button from "@components/Button";
import ImagesGallery2 from "@components/ImagesGallery/ImagesGallery2";
import Icons from "@gstyles/styleguide/icons";
import { useRouteContext } from "@providers/RouteProvider";
import { useTranslationContext } from "@providers/TranslationProvider";
import cx from "classnames";
import React, { useCallback, useEffect, useRef } from "react";
import styles from "./WellbeingCentre.module.scss";
import _ from "lodash";
interface IProps {
  swiperClass: string;
  activeTab: string;
  onChange: (tabKey: string) => void;
  tabs: {
    key: string;
    image: {
      src: string;
      alt: string;
    };
    title: string;
    content: string | React.ReactNode;
    shouldEnquire?: boolean;
    moreInfo: {
      time: string;
      phone: string;
      floor: string;
    };
  }[];
}

export default function MainItem({
  activeTab,
  onChange,
  tabs,
  swiperClass,
}: IProps) {
  const galleryRef = useRef<any>({});
  const onTabChange = (key: string) => () => {
    onChange(key);
  };
  const onSlideChange = useCallback(
    (swiper: any) => {
      const index = _.get(swiper.realIndex, "");
      if (_.isNumber(index)) {
        onChange(tabs[index]?.key);
      }
    },
    [onChange, tabs]
  );
  useEffect(() => {
    if (!!galleryRef.current) {
      galleryRef.current?.slideTo?.(
        tabs.findIndex((tab) => tab.key === activeTab) ?? 0
      );
    }
  }, [activeTab]);
  const { i18n } = useTranslationContext();
  const { router } = useRouteContext();
  return (
    <div className={cx(styles.mainItem)}>
      <ImagesGallery2
        galleryRef={galleryRef}
        onSlideChange={onSlideChange}
        itemClassName={styles.featuredImageItem}
        imageClassName={styles.featuredImage}
        galleryName={swiperClass}
        images={_.castArray(
          tabs.map((item) => ({
            src: item?.image?.src,
            alt: item?.image?.alt,
          }))
        )}
      />
      <div className={cx(styles.infoSection)}>
        <div className={cx(styles.headingTab)}>
          {tabs.map((item, index) => (
            <Fragment key={`heading_${index}`}>
              {index !== 0 && (
                <span className={cx("mx-3", styles.pipeSymbol)}>{"|"}</span>
              )}
              <div
                className={cx(
                  styles.nameTab,
                  activeTab === item.key ? styles.active : styles.inactive
                )}
                onClick={onTabChange(item.key)}
              >
                <div className={cx(styles.title)}>{item.title}</div>
              </div>
            </Fragment>
          ))}
        </div>
        {tabs.map((item, index) => (
          <div
            key={index}
            className={cx(activeTab === item.key ? "block" : "hidden")}
          >
            <div className={cx(styles.content)}>{item.content}</div>
            {!!item?.shouldEnquire && (
              <Button
                type="icon"
                suffix="shape-arrow"
                className={cx(styles.enquireBtn)}
                label={i18n.t("Button.makeAnEnquire")}
                onClick={() => router.push("contact")}
              />
            )}
            <div className={cx(styles.moreInfoSection)}>
              <div className={cx(styles.moreInfoItemSection)}>
                <div className={cx(styles.label)}>
                  {i18n.t("Wellness.hours")}
                </div>
                <div className="flex items-center">
                  <Icons name="clock-outline" className={cx(styles.icon)} />
                  <div className={cx(styles.iconContent)}>
                    {item.moreInfo.time}
                  </div>
                </div>
              </div>
              <div className={cx(styles.moreInfoItemSection)}>
                <div className={cx(styles.label)}>
                  {i18n.t("Wellness.reservations")}
                </div>
                <div className="flex items-center">
                  <Icons name="phone-outline" className={cx(styles.icon)} />
                  <div className={cx(styles.iconContent)}>
                    {item.moreInfo.phone}
                  </div>
                </div>
              </div>
              <div className={cx(styles.moreInfoItemSection)}>
                <div className={cx(styles.label)}>
                  {i18n.t("Wellness.location")}
                </div>
                <div className="flex items-center">
                  <Icons
                    name="location-marker-outline"
                    className={cx(styles.icon)}
                  />
                  <div className={cx(styles.iconContent)}>
                    {item.moreInfo.floor}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
